
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/[...slug]",
      function () {
        return require("private-next-pages/site/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/[...slug]"])
      });
    }
  